<template>
  <div class="deluxe-layout theme-directory" :class="{ dark: isDark, 'collapsed-sidebar': isSidebarCollapsed }">
    <div class="wrapper">
      <div class="wrapper__inner">
        <DeluxeSidebar
          :collapsed="isSidebarCollapsed"
          @toggle-collapse="toggleSidebar"
        />

        <main class="content theme-directory">
          <div class="content__top d-print-none">
            <DeluxeBreadcrumbs />

            <div class="deluxe-topbar__actions">
              <button type="button" class="deluxe-icon-button deluxe-topbar__icon-doc" title="Document search">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M17.8018 13.1949V10.8755C17.8018 10.0846 17.4876 9.32606 16.9283 8.7668C16.3691 8.20755 15.6105 7.89336 14.8196 7.89336H13.4942C13.2306 7.89336 12.9778 7.78863 12.7913 7.60221C12.6049 7.41579 12.5002 7.16295 12.5002 6.89932V5.57393C12.5002 4.78302 12.186 4.0245 11.6267 3.46524C11.0675 2.90598 10.309 2.5918 9.51806 2.5918H7.86133M12.4834 14.5035L13.8256 15.8457M12.4834 14.5035C12.6988 14.2881 12.8698 14.0326 12.9863 13.7512C13.1029 13.4698 13.1629 13.1682 13.1629 12.8636C13.1629 12.2484 12.9185 11.6585 12.4835 11.2235C12.0486 10.7885 11.4586 10.5441 10.8435 10.5441C10.2283 10.5441 9.63835 10.7885 9.20337 11.2235C8.76839 11.6585 8.52402 12.2484 8.52402 12.8636C8.52402 13.1682 8.58402 13.4698 8.70058 13.7512C8.81714 14.0326 8.98799 14.2883 9.20337 14.5037C9.41875 14.719 9.67444 14.8899 9.95585 15.0065C10.2373 15.123 10.5389 15.183 10.8435 15.183C11.148 15.183 11.4497 15.123 11.7311 15.0065C12.0125 14.8899 12.268 14.7189 12.4834 14.5035ZM9.84941 2.5918H5.54189C4.99318 2.5918 4.54785 3.03713 4.54785 3.58584V18.1651C4.54785 18.7138 4.99318 19.1592 5.54189 19.1592H16.8077C17.3564 19.1592 17.8018 18.7138 17.8018 18.1651V10.5441C17.8018 8.43505 16.9639 6.41234 15.4726 4.92098C13.9812 3.42963 11.9585 2.5918 9.84941 2.5918Z" stroke="#777777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>

              <div class="deluxe-language">
                <button type="button" class="deluxe-icon-button deluxe-topbar__icon-language" title="Language" @click.stop="isLanguageOpen = !isLanguageOpen">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M9.08105 17.5859L13.4561 8.21094L17.8311 17.5859M10.3311 15.0859H16.5811M2.83105 4.7701C4.48972 4.5637 6.1596 4.46045 7.83105 4.46094M7.83105 4.46094C8.76439 4.46094 9.69189 4.4926 10.6094 4.55594M7.83105 4.46094V2.58594M10.6094 4.55594C9.64439 8.9676 6.73939 12.6526 2.83105 14.6709M10.6094 4.55594C11.3561 4.60677 12.0969 4.67844 12.8311 4.7701M9.00689 11.8493C7.64019 10.4598 6.557 8.81759 5.81772 7.01427" stroke="#777777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
                <ul v-if="isLanguageOpen" class="lang">
                  <li><button type="button" @click="changeLocale('en')">English</button></li>
                  <li><button type="button" @click="changeLocale('zh-CN')">Chinese</button></li>
                </ul>
              </div>

              <button
                type="button"
                class="deluxe-icon-button deluxe-icon-button--accent deluxe-topbar__icon-bulb"
                :title="isDark ? 'Light mode' : 'Dark mode'"
                @click="toggleDarkMode"
              >
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <g clip-path="url(#clip0_directory_bulb)">
                    <path d="M11.0581 16.2418V11.603V16.2418ZM11.0581 11.603C11.5051 11.6033 11.9504 11.5472 12.3834 11.436L11.0581 11.603ZM11.0581 11.603C10.611 11.6033 10.1657 11.5472 9.73267 11.436L11.0581 11.603ZM13.0461 18.0435C11.7325 18.2929 10.3836 18.2929 9.06997 18.0435H13.0461ZM12.3834 20.1491C11.5023 20.2413 10.6139 20.2413 9.73267 20.1491H12.3834ZM13.0461 16.2418V16.0722C13.0461 15.2036 13.6275 14.4614 14.3786 14.0258C15.6404 13.2951 16.6259 12.1687 17.1826 10.821C17.7393 9.47339 17.8359 7.97979 17.4576 6.57164C17.0793 5.1635 16.2472 3.91942 15.0901 3.03218C13.9331 2.14494 12.5157 1.66406 11.0576 1.66406C9.59954 1.66406 8.18217 2.14494 7.02511 3.03218C5.86805 3.91942 5.0359 5.1635 4.6576 6.57164C4.2793 7.97979 4.37597 9.47339 4.93263 10.821C5.48928 12.1687 6.47486 13.2951 7.73663 14.0258C8.48769 14.4614 9.06997 15.2036 9.06997 16.0722V16.2418" fill="#FF671F" fill-opacity="0.6" />
                    <path d="M11.0581 16.2418V11.603M11.0581 11.603C11.5051 11.6033 11.9504 11.5472 12.3834 11.436M11.0581 11.603C10.611 11.6033 10.1657 11.5472 9.73267 11.436M13.0461 18.0435C11.7325 18.2929 10.3836 18.2929 9.06997 18.0435M12.3834 20.1491C11.5023 20.2413 10.6139 20.2413 9.73267 20.1491M13.0461 16.2418V16.0722C13.0461 15.2036 13.6275 14.4614 14.3786 14.0258C15.6404 13.2951 16.626 12.1687 17.1826 10.821C17.7393 9.47339 17.8359 7.97979 17.4576 6.57164C17.0793 5.1635 16.2472 3.91942 15.0901 3.03218C13.9331 2.14494 12.5157 1.66406 11.0576 1.66406C9.59954 1.66406 8.18217 2.14494 7.02511 3.03218C5.86805 3.91942 5.0359 5.1635 4.6576 6.57164C4.2793 7.97979 4.37597 9.47339 4.93263 10.821C5.48928 12.1687 6.47486 13.2951 7.73663 14.0258C8.48769 14.4614 9.06997 15.2036 9.06997 16.0722V16.2418" stroke="#FF671F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_directory_bulb">
                      <rect width="21.2062" height="21.2062" fill="white" transform="translate(0.189453 0.603516)" />
                    </clipPath>
                  </defs>
                </svg>
              </button>

              <a class="deluxe-mmoser-logo" :href="projectUrl" title="MMOSER ASSOCIATES">
                <img src="/mmoser-associates.svg" alt="MMOSER ASSOCIATES" />
              </a>
            </div>
          </div>

          <div class="content__wrapper theme-directory">
            <div class="content__inner">
              <div class="directory-content-panel">
                <slot />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import DeluxeBreadcrumbs from '@/components/deluxe/DeluxeBreadcrumbs.vue'
import DeluxeSidebar from '@/components/deluxe/DeluxeSidebar.vue'
import { LocaleNameVariable } from '@/translations/i18n.js'
import 'dotenv/config'

const LocalStorageModeName = 'lens_ui_mode'
const LocalStorageSidebarName = 'lens_deluxe_sidebar_collapsed'

export default {
  name: 'DeluxeLayout',
  components: {
    DeluxeBreadcrumbs,
    DeluxeSidebar
  },
  data() {
    return {
      isDark: window.localStorage.getItem(LocalStorageModeName) === 'dark',
      isSidebarCollapsed: window.localStorage.getItem(LocalStorageSidebarName) === 'true',
      isLanguageOpen: false,
      projectUrl: process.env.VUE_APP_PROJECT_URL
    }
  },
  mounted() {
    this.syncBodyClasses()
    document.addEventListener('click', this.closeLanguageFromOutside)
  },
  beforeUnmount() {
    this.clearBodyClasses()
    document.removeEventListener('click', this.closeLanguageFromOutside)
  },
  watch: {
    isDark() {
      this.syncBodyClasses()
    },
    isSidebarCollapsed() {
      this.syncBodyClasses()
    }
  },
  methods: {
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed
      window.localStorage.setItem(LocalStorageSidebarName, String(this.isSidebarCollapsed))
    },
    toggleDarkMode() {
      this.isDark = !this.isDark
      window.localStorage.setItem(LocalStorageModeName, this.isDark ? 'dark' : 'light')
    },
    changeLocale(value) {
      this.$i18n.locale = value
      window.localStorage.setItem(LocaleNameVariable, value)
      document.documentElement.lang = value
      this.isLanguageOpen = false
    },
    closeLanguageFromOutside(event) {
      if (!event.target.closest('.deluxe-language')) {
        this.isLanguageOpen = false
      }
    },
    syncBodyClasses() {
      document.body.classList.add('deluxe-body', 'theme-directory')
      document.body.classList.toggle('dark', this.isDark)
      document.body.classList.toggle('collapsed-sidebar', this.isSidebarCollapsed)
    },
    clearBodyClasses() {
      document.body.classList.remove('deluxe-body', 'theme-directory', 'dark', 'collapsed-sidebar')
    }
  }
}
</script>
